import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Container, CssBaseline, Grid } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { lightTheme } from "./config/theme";
import HomeScreen from "./screens/HomeScreen";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import CreateRoom from "./screens/admin/CreateRoom";
import ListRooms from "./screens/admin/ListRooms";
import EditRoom from "./screens/admin/EditRoom";
import CreateReservation from "./screens/CreateReservation";
import MyReservations from "./screens/MyReservations";
import ListAllReservations from "./screens/admin/ListAllReservations";
import UserList from "./screens/admin/UserList";
import Contacts from "./screens/Contacts";

const App = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <UserAuthContextProvider>
        <Grid container>
          <Grid item xs={12}>
            <Router>
              <CssBaseline />
              <ToastContainer />

              <Routes>
                <Route
                  path="/reservation/:id"
                  element={<CreateReservation />}
                />
                <Route path="/createRoom" element={<CreateRoom />} />
                <Route path="/signup" element={<RegisterScreen />} />
                <Route path="/users" element={<UserList />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/reservations" element={<MyReservations />} />
                <Route
                  path="admin/reservations"
                  element={<ListAllReservations />}
                />
                <Route path="/rooms" element={<ListRooms />} />
                <Route path="/rooms/:id" element={<EditRoom />} />
                <Route path="/home" element={<HomeScreen />} />

                <Route path="/" element={<LoginScreen />} />
              </Routes>
            </Router>
          </Grid>
        </Grid>
      </UserAuthContextProvider>
    </ThemeProvider>
  );
};

export default App;
